import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AttestaaiLogo from "../Assets/images/attestaai-logo.png";
import ProgressBar from "./ProgressBar";
import CreditsProgressBar from "./CreditsProgressBar";
//pass request back end
import axios from "axios";

import { API_BASE_URL } from "../../global";

const SideBar = ({ handleShowRecentUpload, handleShowUploads, handleContinueClick, handleShowSettings, recentCasesData, tokensData, handlesupplementClick, handleaddagentClick, handleaddagentassistantClick, handleaddadditionalappsClick  }) => {
  const navigate = useNavigate();

  const [isSidebarActive, setIsSidebarActive] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarActive(prev => !prev);
  };


  useEffect(() => {
    const intervalId = setInterval(() => {
      const closeSide = localStorage.getItem("closeside");
      if (closeSide === "1") {
        setIsSidebarActive(false);
        localStorage.setItem("closeside", "3");
      }
      else if (closeSide === "2") {
        setIsSidebarActive(true);
        localStorage.setItem("closeside", "3");
      }
    }, 500);

    return () => clearInterval(intervalId); // cleanup on unmount
  }, []);

  const getFirstLetter = (data) => {
    return data && data.trim() ? data.trim().charAt(0).toUpperCase() : "";
  };
  const handleLogOutbkp = () => {
    localStorage.clear();
    localStorage.setItem("attesta_timeline_logout", Date.now());
    navigate("/");
  };
  const handleLogOut = async () => {

    try {
      const response = await axios.post(`${API_BASE_URL}logout`);
      if (response.data && response.data.status && response.data.status === 1) {
        localStorage.clear();
        localStorage.setItem("attesta_timeline_logout", Date.now());
        navigate("/");
      } else {

      }
    } catch (err) {

    }
  };



  return (
    // <div className="topbar d-print-none">
    //   <div className="container-fluid px-1">
    //     <div className="main-wrapper">

    //     </div>
    //   </div>
    // </div>

    <div id="div1" className={`left-ctn ${isSidebarActive ? 'active' : ''}`}>
      <div className="card hst-file-main">
        <div className="up-file-title gap-1">
          <button
            id="toggleBtn"
            onClick={toggleSidebar}
            className="btn data-btn"
          >
            {/* close hover button When it is active */}
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              id="close-svg"
              // style={{ display: "block" }}
              style={{ display: isSidebarActive ? 'block' : 'none' }}
              className="shrink-0 opacity-100 scale-100 group-hover:scale-100 group-hover:opacity-0 transition-all text-text-300"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 10C5 9.85913 5.05943 9.72479 5.16366 9.63003L10.6637 4.63003C10.868 4.44428 11.1842 4.45933 11.37 4.66366C11.5557 4.86799 11.5407 5.18422 11.3363 5.36997L6.7933 9.5L17.5 9.5C17.7761 9.5 18 9.72386 18 10C18 10.2761 17.7761 10.5 17.5 10.5L6.7933 10.5L11.3363 14.63C11.5407 14.8158 11.5557 15.132 11.37 15.3363C11.1842 15.5407 10.868 15.5557 10.6637 15.37L5.16366 10.37C5.05943 10.2752 5 10.1409 5 10Z"
              ></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 2C2.77614 2 3 2.22386 3 2.5L3 17.5C3 17.7761 2.77614 18 2.5 18C2.22385 18 2 17.7761 2 17.5L2 2.5C2 2.22386 2.22386 2 2.5 2Z"
              ></path>
            </svg>

            {/* open hover button When it is not active */}
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              id="open-svg"
              // style={{ display: "none" }}
              style={{ display: isSidebarActive ? 'none' : 'block' }}
              className="shrink-0 opacity-100 scale-100 group-hover:scale-100 group-hover:opacity-0 transition-all text-text-300"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5 2C17.7761 2 18 2.22386 18 2.5V17.5C18 17.7761 17.7761 18 17.5 18C17.2239 18 17 17.7761 17 17.5V2.5C17 2.22386 17.2239 2 17.5 2ZM8.63003 4.66366C8.81578 4.45933 9.13201 4.44428 9.33634 4.63003L14.8363 9.63003C14.9406 9.72479 15 9.85913 15 10C15 10.1409 14.9406 10.2752 14.8363 10.37L9.33634 15.37C9.13201 15.5557 8.81578 15.5407 8.63003 15.3363C8.44428 15.132 8.45934 14.8158 8.66366 14.63L13.2067 10.5H2.5C2.22386 10.5 2 10.2761 2 10C2 9.72386 2.22386 9.5 2.5 9.5H13.2067L8.66366 5.36997C8.45934 5.18422 8.44428 4.86799 8.63003 4.66366Z"
              />
            </svg>
          </button>

          <h4 className="card-title font-normal text-disapper h-30 d-flex align-items-center">
            <Link to="/welcome">
              <img src={AttestaaiLogo} alt="logo" />
            </Link>
          </h4>
        </div>
        {/* end card-header */}

        <div className="card-body pt-0 px-0 d-flex flex-column justify-content-between">
          <div className="position-relative">
            <div className="hst-file-inner d-flex flex-column gap-2">
              <div
                // to="/welcome"
                // onClick={handleShowUploads}
                onClick={
                  !localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                    ? handleShowUploads
                    : undefined
                }
                // className="new-upload d-flex gap-2 align-items-center h-30"
                className={`new-upload d-flex gap-2 align-items-center h-30 ${localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                  ? "disabled-div text-dark"
                  : ""
                  }`}
              >
                <i
                  className="fa-solid fa-circle-plus"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="New Upload"
                  // onClick={handleShowUploads}
                  onClick={
                    !localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                      ? handleShowUploads
                      : undefined
                  }
                ></i>
                <h4 className="text-disapper">New {localStorage.getItem('userdocumentlabel') || 'Project'}</h4>
              </div>

              <hr className="divider my-0" />

              <div
                // to="/uploads"
                // onClick={handleShowRecentUpload}
                onClick={
                  !localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                    ? handleShowRecentUpload
                    : undefined
                }
                // className="uploads d-flex gap-2 align-items-center h-30 ps-1"
                className={`uploads d-flex gap-2 align-items-center h-30 ps-1 ${localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                  ? "disabled-div text-dark"
                  : ""
                  }`}
              >
                <i
                  className="fa-regular fa-file"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Recent"
                  // onClick={handleShowRecentUpload}
                  onClick={
                    !localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                      ? handleShowRecentUpload
                      : undefined
                  }
                ></i>
                <h4 className="text-disapper">
                  Recent {localStorage.getItem('userdocumentlabel')
                    ? `${localStorage.getItem('userdocumentlabel')}s`
                    : 'Projects'}
                </h4>
              </div>

              <ProgressBar handleContinueClick={handleContinueClick} allCasedata={recentCasesData}  handlesupplementClick={handlesupplementClick} handleaddagentClick={handleaddagentClick} handleaddagentassistantClick={handleaddagentassistantClick} handleaddadditionalappsClick={handleaddadditionalappsClick}/>
            </div>
          </div>

          <div className="profle-wrapper d-flex flex-column gap-3">
            {/* <!-- credit usage --> */}
            {!localStorage.getItem("view")?.toLowerCase().includes("approvalpage") && (
              tokensData ? (
                <CreditsProgressBar spent={parseFloat(tokensData.Used_token) || 0} limit={parseFloat(tokensData.Total_token) || 0} handleShowSettings={handleShowSettings} />
              ) : (<CreditsProgressBar spent={0} limit={0} handleShowSettings={handleShowSettings} />))}


            {/* <div className="credit-usage-wrapper mb-3 text-disapper">
                    <div className="d-flex align-items-center mb-2">
                      <span className="credit-usage-label mb-0">
                        Credit usage
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                      <span className="credit-usage-value">
                        Spent <strong>238</strong>
                      </span>
                      <span className="credit-usage-value">
                        Limit <strong>1000</strong>
                      </span>
                    </div>
                    <div className="progress progress-custom-bg d-flex align-items-center">
                      <div
                        className="progress-bar progress-bar-custom"
                        role="progressbar"
                        style={{ width: "24%", borderRadius: "4px" }}
                      ></div>
                    </div>
                  </div> */}
            {/* <!-- end credit usage --> */}
            {/* Profile Dropdown Menu */}
            <div
              className="dropdown-menu"
              style={{
                position: "absolute",
                padding: "10px",
                width: "300.27px",
                boxShadow: "none",
                border: "1px solid #e7e7e7",
                transform: "translate(24px, 107px)",
              }}
              data-popper-placement="bottom-start"
            >
              <div className="dd-profile w-100 justify-content-start">
                <div className="mb-0 text-muted d-flex flex-row align-items-center h-30 gap-2">
                  <div
                    className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Profile"
                  >
                    {getFirstLetter(localStorage.getItem("username") || 'Alden')}
                  </div>
                  <div className="profile-name d-flex flex-column text-start">
                    {localStorage.getItem("username") || 'Alden'}
                    <span style={{ fontSize: '10px', wordBreak: 'break-all', whiteSpace: 'normal' }}>{localStorage.getItem("useremail") || 'alden@gmail.com'}</span>
                  </div>
                </div>
              </div>

              <div className="divider my-2" />

              <div
                // to="/settings"
                // onClick={handleShowSettings}
                // className="logout-wrapper cursor-pointer"
                onClick={
                  !localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                    ? handleShowSettings
                    : undefined
                }
                className={`logout-wrapper ${localStorage.getItem("view")?.toLowerCase().includes("approvalpage")
                  ? "disabled-div"
                  : "cursor-pointer"
                  }`}
              >
                <i className="fa-solid fa-gear" />
                <h5 className="mb-0 ms-2">Settings</h5>
              </div>

              <div className="logout-wrapper cursor-pointer" onClick={() => { handleLogOut() }}>
                <i className="fa-solid fa-power-off" />
                <h5 className="mb-0 ms-2">Log out</h5>
              </div>
            </div>

            {/* Toggle Button */}
            <button
              type="button"
              className="btn dropdown-toggle show"
              style={{ padding: 0 }}
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <div className="profile d-flex justify-content-between align-items-center cursor-pointer dropdown-toggle">
                <div className="mb-0 text-muted d-flex flex-row align-items-center h-30 gap-2">
                  <div
                    className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Profile"
                  >
                    {getFirstLetter(localStorage.getItem("username") || 'Alden')}
                  </div>
                  <div className="profile-name d-flex flex-column text-start text-disapper">
                    {localStorage.getItem("username") || 'Alden'}
                    <span style={{ fontSize: '10px', wordBreak: 'break-all', whiteSpace: 'normal' }}>{localStorage.getItem("useremail") || 'alden@gmail.com'}</span>
                  </div>
                </div>
                <i className="fa-solid fa-angle-down text-disapper" />
              </div>
            </button>
          </div>
        </div>
        {/* end card-body */}
      </div>
    </div>
  );
};

export default SideBar;
